<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-plus-circle"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Grid de Cards -->
      <div class="cards-container">
        <!-- Coluna Esquerda: Valor e Data -->
        <div class="column-left">
          <!-- Card: Valor e Data -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon values-icon">
                <i class="pi pi-dollar"></i>
              </div>
              <span class="card-header-title">{{ texts.valor_e_data }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Moeda e Valor lado a lado -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.moeda }} <span class="required">*</span></label>
                  <p-dropdown id="moeda" [options]="moeda" [(ngModel)]="form.moeda" optionLabel="label"
                    (ngModelChange)="onMoedaChange($event)" [placeholder]="placeholders.selecionar"
                    appendTo="body" [class.error-field]="isFormSubmitted && !form.moeda">
                    <ng-template pTemplate="selectedItem" let-moeda>
                      <div class="dropdown-moeda-item" *ngIf="moeda">
                        <img [src]="moeda.flagUrl" class="flag-icon-small" alt="" />
                        <span>{{ moeda.label }}</span>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-moeda>
                      <div class="dropdown-moeda-item">
                        <img [src]="moeda.flagUrl" class="flag-icon-small" alt="" />
                        <span>{{ moeda.label }}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
                <div class="form-field half">
                  <label class="form-label">{{ labels.valor }} <span class="required">*</span></label>
                  <div class="currency-input-container">
                    <input type="text" pInputText
                      [placeholder]="placeholders.valor"
                      class="currency-input-with-symbol w-full"
                      [value]="montanteStr"
                      (input)="formataCampoValor($event)"
                      [class.error-field]="isFormSubmitted && !form.valor && form.valor !== 0" />
                    <span class="currency-symbol-inside-input">{{ getSelectedCurrencySymbol() }}</span>
                  </div>
                </div>
                <!-- Data (full) -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.data }} <span class="required">*</span></label>
                  <div class="date-buttons-group">
                    <button pButton type="button" [label]="labels.hoje"
                      class="p-button-sm"
                      [class.p-button-outlined]="dataSelecionada !== 'hoje'"
                      (click)="selecionarData('hoje')">
                    </button>
                    <button pButton type="button" [label]="labels.ontem"
                      class="p-button-sm"
                      [class.p-button-outlined]="dataSelecionada !== 'ontem'"
                      (click)="selecionarData('ontem')">
                    </button>
                    <span class="calendar-inline-wrapper">
                      <button pButton type="button" [label]="outrosLabel"
                        class="p-button-sm"
                        [class.p-button-outlined]="dataSelecionada !== 'outros'"
                        (click)="abrirCalendario()">
                      </button>
                      <p-calendar #calendario [(ngModel)]="form.emissao"
                        dateFormat="dd/mm/yy" [readonlyInput]="true"
                        [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2030"
                        (onSelect)="onDataSelecionada()"
                        [showIcon]="false"
                        appendTo="body">
                      </p-calendar>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Direita: Dados da Receita -->
        <div class="column-right">
          <!-- Card: Dados da Receita -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon">
                <i class="pi pi-file-edit"></i>
              </div>
              <span class="card-header-title">{{ texts.dados_da_receita }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Tipo de Receita (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.tipo_de_receita }} <span class="required">*</span></label>
                  <p-dropdown [options]="tiposReceita" optionLabel="label"
                    [placeholder]="placeholders.selecionar" optionValue="value"
                    [(ngModel)]="form.tipoReceita" [showClear]="true" appendTo="body"
                    [filter]="true" filterBy="label"
                    [class.error-field]="isFormSubmitted && !form.tipoReceita">
                    <ng-template let-item pTemplate="item">
                      <div class="flex align-items-center gap-2">
                        <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                          [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: item.cor || '#eceff4' }">
                          <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
                        </div>
                        <span>{{ item.label }}</span>
                      </div>
                    </ng-template>
                    <ng-template let-item pTemplate="selectedItem">
                      <div class="flex align-items-center gap-2" *ngIf="item">
                        <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                          [ngStyle]="{ width: '22px', height: '22px', 'min-width': '22px', background: item.cor || '#eceff4' }">
                          <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.6rem;"></i>
                        </div>
                        <span>{{ item.label }}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
                <!-- Pessoa (half) - opcional -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.pessoa }}</label>
                  <div class="dialog-actions">
                    <app-entity-selector
                      [config]="clienteSelectorConfig"
                      [(value)]="pessoaSelecionada"
                      (entitySelected)="onPessoaSelecionada($event)"
                      (addNew)="abrirDialogoCliente()">
                    </app-entity-selector>
                  </div>
                </div>
                <!-- Descricao (full) - obrigatoria quando tipo OUTROS -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.descricao }} <span class="required" *ngIf="form.tipoReceita === 'OUTROS'">*</span></label>
                  <input type="text" pInputText [(ngModel)]="form.descricao"
                    [placeholder]="placeholders.descricao" class="w-full"
                    [class.error-field]="isFormSubmitted && form.tipoReceita === 'OUTROS' && (!form.descricao || form.descricao.trim().length < 10)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="botoes.limpar"
          severity="secondary" icon="pi pi-eraser"
          (click)="limparFormulario()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="botoes.salvar"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="botoes.atualizar"
          icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

<!-- Card: Lista de Receitas -->
<div class="table-card">
  <div class="card-header card-header-table">
    <div class="card-header-left">
      <div class="card-header-icon table-icon">
        <i class="pi pi-list"></i>
      </div>
      <span class="card-header-title">{{ texts.lista_de_receitas }}</span>
    </div>
    <div class="card-header-filters">
      <!-- Filtro Conta (inline no header) -->
      <div class="header-filter-field">
        <p-dropdown [options]="contas" [(ngModel)]="filtroConta"
          optionLabel="label" optionValue="value"
          [placeholder]="labels.filtro_conta" [filter]="true"
          filterBy="label" [showClear]="true" appendTo="body"
          [style]="{ width: '100%' }"
          (onChange)="onContaFiltroChange()"
          (onClear)="onContaFiltroChange()">
          <ng-template pTemplate="selectedItem" let-conta>
            <div class="dropdown-conta-item" *ngIf="conta">
              <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
              <span>{{ conta.label }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-conta>
            <div class="dropdown-conta-item">
              <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
              <span>{{ conta.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <!-- Filtro Periodo (inline no header) -->
      <div class="header-filter-field">
        <app-periodo-filtro
          modo="avancado"
          [opcoes]="opcoesPeriodo"
          [valorPadrao]="'showAll'"
          [persistir]="true"
          [textoExibicao]="periodoReceitaTexto"
          styleClass="w-full"
          (periodoChanged)="onPeriodoReceitaChanged($event)">
        </app-periodo-filtro>
      </div>
    </div>
    <!-- Acoes do header: seletor de colunas + filtros avancados + nova receita -->
    <div class="card-header-actions">
      <app-column-selector
        [columns]="columns"
        [storageKey]="STORAGE_KEY"
        (columnsChange)="onColumnsChange($event)">
      </app-column-selector>
      <button pButton icon="pi pi-sliders-h"
        class="p-button-sm header-filter-btn"
        [pTooltip]="texts.filtros_avancados" tooltipPosition="top"
        (click)="sidebarFiltrosVisible = true">
      </button>
      <button pButton
        [label]="texts.nova_receita"
        icon="pi pi-plus"
        class="btn-primary btn-sm header-actions-cta"
        (click)="novaReceita()">
      </button>
    </div>
  </div>
  <div class="card-content">

    <!-- Cards de Totais por Moeda (sempre visiveis) -->
    <div class="totais-moeda-section">
      <div class="totais-moeda-cards">
        <div class="total-moeda-card total-guarani"
          *ngIf="moedasPermitidas.has('GUARANI') && (!contaBancariaAtiva || moedaContaSelecionada === 'GUARANI')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'GUARANI'"
          (click)="filtrarPorMoeda('GUARANI')">
          <div class="total-moeda-icon">
            <img src="assets/images/paraguay-flag.jpg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_guarani }}</span>
            <span class="total-moeda-valor" *ngIf="!loadingTotais">
              Gs {{ totais.valorTotalEmGuarani | number:'1.0-0':'es-PY' }}
            </span>
            <span class="total-moeda-valor" *ngIf="loadingTotais">...</span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'GUARANI'"></i>
        </div>
        <div class="total-moeda-card total-dolar"
          *ngIf="moedasPermitidas.has('DOLAR') && (!contaBancariaAtiva || moedaContaSelecionada === 'DOLAR')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'DOLAR'"
          (click)="filtrarPorMoeda('DOLAR')">
          <div class="total-moeda-icon">
            <img src="assets/images/usa-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_dolar }}</span>
            <span class="total-moeda-valor" *ngIf="!loadingTotais">
              $ {{ totais.valorTotalEmDolar | number:'1.2-2':'en-US' }}
            </span>
            <span class="total-moeda-valor" *ngIf="loadingTotais">...</span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'DOLAR'"></i>
        </div>
        <div class="total-moeda-card total-real"
          *ngIf="moedasPermitidas.has('REAL') && (!contaBancariaAtiva || moedaContaSelecionada === 'REAL')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'REAL'"
          (click)="filtrarPorMoeda('REAL')">
          <div class="total-moeda-icon">
            <img src="assets/images/br-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_real }}</span>
            <span class="total-moeda-valor" *ngIf="!loadingTotais">
              R$ {{ totais.valorTotalEmReal | number:'1.2-2':'pt-BR' }}
            </span>
            <span class="total-moeda-valor" *ngIf="loadingTotais">...</span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'REAL'"></i>
        </div>
        <div class="total-moeda-card total-peso"
          *ngIf="moedasPermitidas.has('PESO') && (!contaBancariaAtiva || moedaContaSelecionada === 'PESO')"
          [class.total-moeda-card--active]="filtroMoedaSelecionada === 'PESO'"
          (click)="filtrarPorMoeda('PESO')">
          <div class="total-moeda-icon">
            <img src="assets/images/argentina-flag.svg" class="flag-icon-small" alt="" />
          </div>
          <div class="total-moeda-info">
            <span class="total-moeda-label">{{ texts.total_peso }}</span>
            <span class="total-moeda-valor" *ngIf="!loadingTotais">
              $ {{ (totais.valorTotalEmPeso ?? 0) | number:'1.2-2':'es-AR' }}
            </span>
            <span class="total-moeda-valor" *ngIf="loadingTotais">...</span>
          </div>
          <i class="pi pi-filter-fill total-moeda-filtro-icon" *ngIf="filtroMoedaSelecionada === 'PESO'"></i>
        </div>
      </div>
    </div>


    <!-- Tabela -->
    <p-table [value]="receitas" [loading]="loading"
      sortMode="single"
      [defaultSortOrder]="1"
      [customSort]="true"
      (sortFunction)="customSort($event)"
      [tableStyle]="{ 'width': '100%', 'margin-top': '16px' }">

      <ng-template pTemplate="header">
        <tr>
          <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 8%">
            {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('emissao')" pSortableColumn="emissao" style="width: 18%">
            {{ labels.data_emissao }}<p-sortIcon [field]="'emissao'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('observacao')" pSortableColumn="observacao" style="width: 22%">
            {{ labels.observacao }}<p-sortIcon [field]="'observacao'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('tipoReceita')" pSortableColumn="tipoReceita" style="width: 18%">
            {{ labels.tipo_receita }}<p-sortIcon [field]="'tipoReceita'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('pessoa')" pSortableColumn="nomePessoa" style="width: 15%">
            {{ labels.pessoa }}<p-sortIcon [field]="'nomePessoa'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('valor')" pSortableColumn="valor" class="num-col" style="width: 17%">
            {{ labels.valor }}<p-sortIcon [field]="'valor'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('acoes')" style="width: 17%">{{ labels.acoes }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-receita>
        <tr>
          <td [hidden]="!isColumnVisible('id')">{{ receita.id }}</td>
          <td [hidden]="!isColumnVisible('emissao')">{{ receita.emissao | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td [hidden]="!isColumnVisible('observacao')">{{ receita.observacao }}</td>
          <td [hidden]="!isColumnVisible('tipoReceita')">
            <div class="flex align-items-center gap-2">
              <div *ngIf="receita.tipoReceita?.icone || receita.tipoReceita?.cor"
                class="flex align-items-center justify-content-center border-circle"
                [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: receita.tipoReceita?.cor || '#eceff4' }">
                <i class="{{ receita.tipoReceita?.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
              </div>
              <span>{{ receita.tipoReceita?.nome }}</span>
            </div>
          </td>
          <td [hidden]="!isColumnVisible('pessoa')">{{ receita.pessoa?.nome }}</td>
          <td [hidden]="!isColumnVisible('valor')" class="num-col positive">{{ formatarValorMonetario(receita.valor, receita.moedaDeOrigem) }}</td>
          <td [hidden]="!isColumnVisible('acoes')" class="actions">
            <button pButton
              [icon]="getIconeAcao(receita)"
              class="p-button-text p-button-rounded p-button-sm"
              [pTooltip]="getTooltipAcao(receita)" tooltipPosition="top"
              (click)="abrirReceitaNovaAba(receita)">
            </button>
            <button pButton
              [icon]="imprimindoId === receita.id ? 'pi pi-spin pi-spinner' : 'pi pi-print'"
              class="p-button-text p-button-rounded p-button-sm p-button-info"
              [pTooltip]="tooltips.imprimir" tooltipPosition="top"
              [disabled]="imprimindoId === receita.id"
              (click)="imprimirReceita(receita.id, receita.tipo)">
            </button>
            <button pButton icon="pi pi-trash"
              class="p-button-text p-button-rounded p-button-sm p-button-danger"
              [pTooltip]="tooltips.excluir" tooltipPosition="top"
              (click)="deletarReceita(receita.id)">
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ texts.nenhuma_receita }}</div>
              <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ texts.carregando }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao -->
    <div class="pagination-container">
      <div>
        <p-paginator (onPageChange)="onPageChange($any($event))"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [first]="first" [rows]="rows"
          [totalRecords]="totalRecords"
          [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

    </p-tabPanel>

  </p-tabView>
</div>

<!--
  Dialog Forma de Pagamento (Componente reutilizavel).
  Os cards de Dinheiro aplicam DOIS filtros simultaneos sobre a matriz
  canonica MOEDAS_COMPATIVEIS:
    1) Moeda do REGISTRO (moedaPadraoISO) — sincronizada com form.moeda em
       abrirDialogPagamento(). Define quais conversoes sao permitidas a
       partir da nota.
    2) Moeda da EMPRESA (moedaEmpresaISO) — capturada em findEmpresa().
       Impede oferecer cards de moedas que a empresa nao opera (ex.: empresa
       em REAL nunca aceita PESO, mesmo que o registro seja em GUARANI).
  Visibilidade final = intersecao das duas matrizes. Combinada com a
  habilitacao do PESO (cotacao > 0), produz 1-4 cards conforme o cenario.
  O combo de contas aplica a matriz do registro via `[moedaNota]`.
-->
<app-forma-pagamento-dialog
  [(visible)]="mostrarDialogPagamento"
  [totalAPagar]="form.valor || 0"
  [config]="{
    formasPermitidas: ['dinheiro', 'conta'],
    moedaPadrao: moedaPadraoISO,
    habilitarMultiMoeda: true,
    cotacoes: { cotUSD: cotUSD, cotPYG: cotPYG, cotBRL: cotBRL, cotPesoGuarani: cotPesoGuarani, cotRealGuarani: cotRealGuarani },
    labelBotaoConfirmar: ('nova-receita.botoes.confirmar_receita' | translate),
    iconeBotaoConfirmar: 'pi pi-check'
  }"
  [contas]="contasFormatadas"
  [moedaNota]="form.moeda?.value || null"
  [moedaEmpresa]="moedaEmpresaISO"
  [processando]="processandoReceita"
  (confirmar)="onPagamentoConfirmado($event)"
  (cancelar)="mostrarDialogPagamento = false">
</app-forma-pagamento-dialog>

<!-- Sidebar de Filtros Avancados -->
<p-sidebar [(visible)]="sidebarFiltrosVisible" position="right" [style]="{ width: '28rem' }" [blockScroll]="true"
    styleClass="shadow-lg">
    <ng-template pTemplate="header">
        <div class="sidebar-wave-header sidebar-wave-header--info">
            <div class="sidebar-wave-header-content">
                <div class="sidebar-wave-icon-container">
                    <i class="pi pi-sliders-h" aria-hidden="true"></i>
                </div>
                <div class="sidebar-wave-header-text">
                    <h2>{{ texts.filtros_avancados }}</h2>
                    <p>{{ texts.filtros_avancados_subtitulo }}</p>
                </div>
            </div>
            <div class="sidebar-wave-decorative-circle circle-1" aria-hidden="true"></div>
            <div class="sidebar-wave-decorative-circle circle-2" aria-hidden="true"></div>
            <svg class="sidebar-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
            </svg>
        </div>
    </ng-template>

    <div class="sidebar-filtros-body">
        <!-- Filtro Descricao -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.filtro_observacao }}</label>
            <input type="text" pInputText [(ngModel)]="filtroObservacao"
                [placeholder]="placeholders.filtro_observacao" class="w-full" />
        </div>

        <!-- Filtro Cliente -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.filtro_cliente }}</label>
            <app-entity-selector
                [config]="filtroPessoaSelectorConfig"
                [(value)]="filtroPessoaSelecionada"
                (entitySelected)="onFiltroPessoaFiltroSelecionada($event)"
                (valueChange)="$event === undefined && onFiltroPessoaFiltroLimpa()"
                (addNew)="abrirDialogoCliente()"
                panelStyleClass="dropdown-panel-above-modal">
            </app-entity-selector>
        </div>

        <!-- Filtro Tipo de Receita -->
        <div class="sidebar-filtro-field">
            <label class="form-label">{{ labels.filtro_tipo_receita }}</label>
            <p-dropdown [options]="tiposReceitaFiltro" [(ngModel)]="filtroTipoReceita"
                optionLabel="label" optionValue="value"
                [placeholder]="placeholders.selecionar" [filter]="true"
                filterBy="label" [showClear]="true" appendTo="body"
                panelStyleClass="dropdown-panel-above-modal"
                [style]="{ width: '100%' }">
                <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                        <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                            [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: item.cor || '#eceff4' }">
                            <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
                        </div>
                        <span>{{ item.label }}</span>
                    </div>
                </ng-template>
                <ng-template let-item pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2" *ngIf="item">
                        <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                            [ngStyle]="{ width: '22px', height: '22px', 'min-width': '22px', background: item.cor || '#eceff4' }">
                            <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.6rem;"></i>
                        </div>
                        <span>{{ item.label }}</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>

    <!-- Footer do sidebar com botoes -->
    <div class="sidebar-filtros-footer">
        <button pButton [label]="botoes.limpar_filtros"
            icon="pi pi-times" class="p-button-sm p-button-secondary"
            (click)="limparFiltros(); sidebarFiltrosVisible = false">
        </button>
        <button pButton [label]="botoes.filtrar"
            icon="pi pi-search" class="p-button-sm btn-primary"
            (click)="aplicarFiltros(); sidebarFiltrosVisible = false">
        </button>
    </div>
</p-sidebar>

<!-- Dialog Selecionar Formato de Impressao -->
<p-dialog
  [(visible)]="mostrarDialogoImpressao"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '400px', height: 'auto' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-print" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'common.impressao.titulo' | translate }}</h2>
        <p>{{ 'common.impressao.descricao' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <div class="field" style="margin-top: 10px;">
      <div class="p-field-radiobutton" style="margin-bottom: 12px;">
        <p-radioButton name="formatoImpressao" value="A4" [(ngModel)]="opcaoImpressao" inputId="rec-fmt-a4"></p-radioButton>
        <label for="rec-fmt-a4" style="margin-left: 8px;">{{ 'common.impressao.a4' | translate }}</label>
      </div>
      <div class="p-field-radiobutton" style="margin-bottom: 12px;">
        <p-radioButton name="formatoImpressao" value="BOBINA_58" [(ngModel)]="opcaoImpressao" inputId="rec-fmt-58"></p-radioButton>
        <label for="rec-fmt-58" style="margin-left: 8px;">{{ 'common.impressao.bobina_58' | translate }}</label>
      </div>
      <div class="p-field-radiobutton">
        <p-radioButton name="formatoImpressao" value="BOBINA_80" [(ngModel)]="opcaoImpressao" inputId="rec-fmt-80"></p-radioButton>
        <label for="rec-fmt-80" style="margin-left: 8px;">{{ 'common.impressao.bobina_80' | translate }}</label>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary"
      (click)="mostrarDialogoImpressao = false">
      {{ 'common.impressao.fechar' | translate }} (Esc)
    </button>
    <button pButton icon="pi pi-print"
      [loading]="imprimindoId !== null"
      (click)="confirmarImpressao()">
      {{ 'common.impressao.imprimir' | translate }}
    </button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>

<!-- Dialog de Confirmacao de Exclusao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash"
      (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog Adicionar Cliente (componente shared) -->
<app-pessoa-adicionar-dialog
  [(visible)]="visibleDialogCliente"
  tipo="cliente"
  (pessoaCriada)="onClienteCriado($event)"
  (pessoaVinculada)="onClienteVinculado($event)">
</app-pessoa-adicionar-dialog>
